module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-344.bbfb06a.woff2";